import { render, staticRenderFns } from "./CoTwoTransportCarLodgesForm.vue?vue&type=template&id=0a234074&scoped=true&"
import script from "./CoTwoTransportCarLodgesForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportCarLodgesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a234074",
  null
  
)

export default component.exports